import React, { useEffect } from "react";
import "./Radio.css";
import mainImage from "../Assets/rf1.jpeg";
import featuredImage from "../Assets/rf2.jpeg";
import relatedImage1 from "../Assets/rf3.jpeg";
import relatedImage2 from "../Assets/rf4.jpeg";
import relatedImage3 from "../Assets/alarm.jpeg";
import cardImage1 from "../Assets/rf5.jpeg";
import cardImage2 from "../Assets/rf7.jpg";
import cardImage3 from "../Assets/rf6.jpg";

function Radio() {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-scroll:not(.main-image-section)');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((element) => observer.observe(element));

    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <div className="radio-container">
      {/* Main Image Section */}
      <div className="main-image-section">  {/* No animate-on-scroll class */}
  <img src={mainImage} alt="Main" className="main-image" />
  <div className="main-image-overlay">
    <h1>Exploring the Power of Radio Frequency (RF) Waves</h1>
    <p>
      Discover how RF waves revolutionize communication, technology, and
      innovation in the modern world.
    </p>
  </div>
</div>

      {/* Featured Section */}
      <div className="featured-section animate-on-scroll">
        <h2>Radio Frequency Identification</h2>
        <div className="featured-content">
          <img
            src={featuredImage}
            alt="Featured Exhibition"
            className="featured-image-large"
          />
          <div className="related-sub-images">
            <div className="related-item">
              <img
                src={relatedImage1}
                alt="2.4 GHz"
                className="related-image-small"
              />
              <h3>2.4 GHz</h3>
            </div>
            <div className="related-item">
              <img
                src={relatedImage2}
                alt="Sub-GHz"
                className="related-image-small"
              />
              <h3>Sub-GHz</h3>
            </div>
            <div className="related-item">
              <img
                src={relatedImage3}
                alt="Mi-Fi"
                className="related-image-small"
              />
              <h3>MI-FI</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div className="cards-section">
        <h2 className="animate-on-scroll">Explore More</h2>
        <div className="cards-container">
          <div className="card animate-on-scroll">
            <img src={cardImage1} alt="Lora-Wan" className="card-image" />
            <div className="card-content">
              <h3>Lora-Wan</h3>
              <p>
                LoRaWAN is a low-power, long-range wireless protocol designed for
                IoT devices, enabling efficient data transmission over vast
                distances.
              </p>
            </div>
          </div>
          <div className="card animate-on-scroll">
            <img src={cardImage2} alt="Bluetooth" className="card-image" />
            <div className="card-content">
              <h3>Bluetooth</h3>
              <p>
                Bluetooth is a wireless technology for short-range communication,
                widely used in devices like headphones, speakers, and
                smartphones.
              </p>
            </div>
          </div>
          <div className="card animate-on-scroll">
            <img src={cardImage3} alt="Wi-Fi" className="card-image" />
            <div className="card-content">  
              <h3>Wi-Fi</h3>
              <p>
                Wi-Fi enables high-speed internet and network connectivity over
                short to medium distances, powering modern communication.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Radio;